/**
 * Determines if a network error is temporary and likely to resolve automatically.
 * Checks against common Chrome network error codes that indicate transient connectivity issues.
 * These errors typically occur during network transitions, sleep/wake cycles, or temporary connection drops.
 */
export const isTemporaryNetworkError = (error: string | Error) => {
  const temporaryErrors = [
    'net::ERR_NETWORK_IO_SUSPENDED',
    'net::ERR_NAME_NOT_RESOLVED',
    'net::ERR_INTERNET_DISCONNECTED',
    'net::ERR_CONNECTION_RESET',
    'net::ERR_CONNECTION_ABORTED',
    'net::ERR_NETWORK_CHANGED',
    'net::ERR_ADDRESS_UNREACHABLE',
    'net::ERR_CONNECTION_CLOSED',
  ]

  return typeof error === 'object' && temporaryErrors.includes(error.message)
}

export const isPersistentNetworkError = (error: string | Error) => {
  const persistentErrors = ['net::ERR_CONNECTION_REFUSED', 'net::ERR_CONNECTION_TIMEOUT']

  return typeof error === 'object' && persistentErrors.includes(error.message)
}
